module.exports = __webpack_public_path__ + "prod/1.42.2/img/could_plat_bg.7c5d1003.png";